import React from 'react';
import { Stack } from '@mui/material';
import { Form } from 'react-final-form';

import { ConfirmDialog, LoadingOverlay, TextField, Typography } from '@occc-app/design-system';

import { validateEnterOTP } from './validation';
import { EnterOTPCodeFormValues, EnterOTPFormProps } from './types';
import { initialValues } from './initial-values';

const ENTER_OTP_CODE_FORM_ID = 'ENTER_OTP_CODE_FORM_ID';

const renderForm: EnterOTPFormProps['render'] = ({ handleSubmit }) => {
  return (
    <form id={ENTER_OTP_CODE_FORM_ID} onSubmit={handleSubmit}>
      <TextField
        label='OTP Code'
        name={'otp' satisfies keyof EnterOTPCodeFormValues}
        type='text'
        margin='normal'
      />
    </form>
  );
};

type EnterOTPCodeModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onHide: () => void;
  onSubmit: EnterOTPFormProps['onSubmit'];
};

export const EnterOTPCodeModal = ({
  isOpen,
  onHide,
  onSubmit,
  isLoading,
}: EnterOTPCodeModalProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Enter OTP Code'
      open={isOpen}
      onClose={onHide}
      fullWidth={true}
      confirmButtonText='Submit'
      confirmButtonProps={{
        type: 'submit',
        form: ENTER_OTP_CODE_FORM_ID,
      }}
    >
      <Stack>
        {isLoading && <LoadingOverlay />}

        <Typography>Please enter the code sent to the member.</Typography>

        <Form<EnterOTPCodeFormValues>
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={renderForm}
          validate={validateEnterOTP}
        />
      </Stack>
    </ConfirmDialog>
  );
};
